import React from 'react';
import { Link } from 'react-router-dom';

const StatisticsCards = ({ statistics }) => {
    if (!statistics) return null;

    const cards = [
        {
            title: 'Total SFAs',
            value: statistics.total_sfas,
            icon: 'fas fa-file-alt',
            color: 'info',
            link: '/sfa-dashboard'
        },
        {
            title: 'Completed',
            value: statistics.completed_sfas,
            icon: 'fas fa-check-circle',
            color: 'success',
            link: '/sfa-dashboard?status=complete'
        },
        {
            title: 'Pending Review',
            value: statistics.pending_review,
            icon: 'fas fa-clock',
            color: 'warning',
            link: '/sfa-dashboard?status=pending_review'
        },
        {
            title: 'Approved',
            value: statistics.approved,
            icon: 'fas fa-thumbs-up',
            color: 'primary',
            link: '/sfa-dashboard?status=approved'
        },
        {
            title: 'In Review',
            value: statistics.in_review,
            icon: 'fas fa-search',
            color: 'secondary',
            link: '/sfa-dashboard?status=in_review'
        },
        {
            title: 'Rejected',
            value: statistics.rejected,
            icon: 'fas fa-times-circle',
            color: 'danger',
            link: '/sfa-dashboard?status=rejected'
        }
    ];

    return (
        <>
            {cards.map((card, index) => (
                <div key={index} className="col-lg-2 col-md-4 col-sm-6 col-12">
                    <div className={`info-box bg-${card.color}`}>
                        <span className="info-box-icon">
                            <i className={card.icon}></i>
                        </span>
                        <div className="info-box-content">
                            <span className="info-box-text">{card.title}</span>
                            <span className="info-box-number">{card.value}</span>
                            <div className="progress">
                                <div 
                                    className="progress-bar" 
                                    style={{
                                        width: `${statistics.total_sfas > 0 ? (card.value / statistics.total_sfas) * 100 : 0}%`
                                    }}
                                />
                            </div>
                            <span className="progress-description">
                                {statistics.total_sfas > 0 ? `${((card.value / statistics.total_sfas) * 100).toFixed(1)}%` : '0%'} of total
                            </span>
                        </div>
                    </div>
                </div>
            ))}
            
            {/* Additional Statistics Row */}
            <div className="col-lg-12">
                <div className="row">
                    <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="info-box bg-gradient-success">
                            <span className="info-box-icon">
                                <i className="fas fa-percentage"></i>
                            </span>
                            <div className="info-box-content">
                                <span className="info-box-text">Completion Rate</span>
                                <span className="info-box-number">{statistics.completion_rate}%</span>
                                <div className="progress">
                                    <div 
                                        className="progress-bar" 
                                        style={{ width: `${statistics.completion_rate}%` }}
                                    />
                                </div>
                                <span className="progress-description">
                                    Applications completed successfully
                                </span>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="info-box bg-gradient-info">
                            <span className="info-box-icon">
                                <i className="fas fa-dollar-sign"></i>
                            </span>
                            <div className="info-box-content">
                                <span className="info-box-text">Total Approved</span>
                                <span className="info-box-number">
                                    ${statistics.total_amount_approved?.toLocaleString() || '0'}
                                </span>
                                <div className="progress">
                                    <div className="progress-bar" style={{ width: '100%' }} />
                                </div>
                                <span className="progress-description">
                                    Total amount approved for funding
                                </span>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="info-box bg-gradient-warning">
                            <span className="info-box-icon">
                                <i className="fas fa-calendar-alt"></i>
                            </span>
                            <div className="info-box-content">
                                <span className="info-box-text">This Month</span>
                                <span className="info-box-number">{statistics.this_month_sfas}</span>
                                <div className="progress">
                                    <div className="progress-bar" style={{ width: '100%' }} />
                                </div>
                                <span className="progress-description">
                                    New applications this month
                                </span>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="info-box bg-gradient-primary">
                            <span className="info-box-icon">
                                <i className="fas fa-chart-line"></i>
                            </span>
                            <div className="info-box-content">
                                <span className="info-box-text">Recent Activity</span>
                                <span className="info-box-number">{statistics.recent_activity_30_days}</span>
                                <div className="progress">
                                    <div className="progress-bar" style={{ width: '100%' }} />
                                </div>
                                <span className="progress-description">
                                    Applications in last 30 days
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StatisticsCards; 